import React, { useState } from 'react';

import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const LocationSection = ({ formData, errors, onChange, onPrivacyChange }) => {
  const [showLocationPrivacy, setShowLocationPrivacy] = useState(false);

  const cityOptions = [
    { value: 'mumbai', label: 'Mumbai' },
    { value: 'delhi', label: 'Delhi' },
    { value: 'bangalore', label: 'Bangalore' },
    { value: 'hyderabad', label: 'Hyderabad' },
    { value: 'chennai', label: 'Chennai' },
    { value: 'kolkata', label: 'Kolkata' },
    { value: 'pune', label: 'Pune' },
    { value: 'ahmedabad', label: 'Ahmedabad' },
    { value: 'jaipur', label: 'Jaipur' },
    { value: 'surat', label: 'Surat' },
    { value: 'lucknow', label: 'Lucknow' },
    { value: 'kanpur', label: 'Kanpur' },
    { value: 'nagpur', label: 'Nagpur' },
    { value: 'indore', label: 'Indore' },
    { value: 'thane', label: 'Thane' },
    { value: 'bhopal', label: 'Bhopal' },
    { value: 'visakhapatnam', label: 'Visakhapatnam' },
    { value: 'patna', label: 'Patna' },
    { value: 'vadodara', label: 'Vadodara' },
    { value: 'ghaziabad', label: 'Ghaziabad' }
  ];

  const privacyLevelOptions = [
    { value: 'exact', label: 'Show Exact Location', description: 'Others see your exact city' },
    { value: 'approximate', label: 'Show Approximate Location', description: 'Others see nearby area only' },
    { value: 'hidden', label: 'Hide Location', description: 'Location completely hidden' }
  ];

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-warm">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h3 className="text-lg md:text-xl font-heading font-semibold">Location</h3>
        <button
          type="button"
          onClick={() => setShowLocationPrivacy(!showLocationPrivacy)}
          className="flex items-center gap-2 px-3 py-1.5 bg-primary/10 text-primary rounded-lg text-sm font-caption font-medium transition-smooth hover:bg-primary/20"
        >
          <Icon name="Shield" size={16} />
          Privacy
        </button>
      </div>
      <div className="space-y-4 md:space-y-5">
        <Select
          label="City"
          name="city"
          placeholder="Select your city"
          description="Choose the city where you're located"
          options={cityOptions}
          value={formData?.city}
          onChange={(value) => onChange({ target: { name: 'city', value } })}
          error={errors?.city}
          required
          searchable
        />

        {showLocationPrivacy && (
          <div className="p-4 bg-muted rounded-lg space-y-4 animate-slide-down">
            <div className="flex items-center gap-2 mb-3">
              <Icon name="MapPin" size={20} color="var(--color-primary)" />
              <h4 className="text-sm font-caption font-semibold">Location Privacy Settings</h4>
            </div>

            <Select
              label="Location Visibility"
              name="locationPrivacy"
              placeholder="Choose privacy level"
              options={privacyLevelOptions}
              value={formData?.locationPrivacy}
              onChange={(value) => onPrivacyChange('locationPrivacy', value)}
            />

            <Checkbox
              label="Hide from nearby searches"
              description="Don't show my profile in location-based searches"
              checked={formData?.hideFromNearby}
              onChange={(e) => onPrivacyChange('hideFromNearby', e?.target?.checked)}
            />

            <div className="flex items-start gap-2 p-3 bg-warning/10 rounded-lg">
              <Icon name="AlertCircle" size={16} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
              <p className="text-xs text-foreground">
                Hiding your location may reduce match opportunities but increases privacy
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationSection;